module.exports = __webpack_public_path__ + "static/media/10C.19635027.png";